/* eslint-disable quotes */
import { crud } from "../db/indexeddb.service";
import { getSupplementsDB, SUPPLEMENTS_STORE } from "../db/supplements.db";

// By convention, id = -1 is used for the temporary draft of a new supplement.
const TEMP_ID = -1;

const SupplementsLocalService = {
  async saveById(id, supplement, supplementCategories) {
    const db = await getSupplementsDB();
    return crud.put(db, SUPPLEMENTS_STORE, {
      id: id,
      supplement,
      supplementCategories,
    });
  },

  async getById(id) {
    const db = await getSupplementsDB();
    return crud.get(db, SUPPLEMENTS_STORE, id);
  },

  async deleteById(id) {
    const db = await getSupplementsDB();
    return crud.delete(db, SUPPLEMENTS_STORE, id);
  },

  // Saves/updates the temporary draft for a NEW supplement (-1).
  async saveTemp(supplement, supplementCategories) {
    return this.saveById(TEMP_ID, supplement, supplementCategories);
  },

  // Gets the temporary draft for a NEW supplement (-1)
  async getTemp() {
    return this.getById(TEMP_ID);
  },

  // Deletes the temporary draft for a NEW supplement (-1)
  async deleteTemp() {
    return this.deleteById(TEMP_ID);
  },

  // Saves/updates the local draft for an EXISTING supplement (id real).
  async saveDraft(id, supplement, supplementCategories) {
    return this.saveById(id, supplement, supplementCategories);
  },

  // Gets the local draft for an EXISTING supplement.
  async getDraft(id) {
    return this.getById(id);
  },

  // Deletes the local draft for an EXISTING supplement.
  async deleteDraft(id) {
    return this.deleteById(id);
  },
};

export default SupplementsLocalService;
